import { FC } from 'react';

import { Spotlight } from '@/components/ui/spotlight';
import { Title } from './title';

export const Hero: FC = () => {
  return (
    <section className="pb-20 pt-36 scroll-mt-28" id="about">
      <div>
        <Spotlight className="-top-40 -left-10 md:-left-32 md:-top-20 h-screen" fill="white" />
        <Spotlight className="top-10 left-3/4 h-[80vh] w-[50vw]" fill="purple" />
        <Spotlight className="top-28 left-80 md:-left-32 h-[80vh] w-[50vw]" fill="blue" />
      </div>
      <Title />
    </section>
  );
};
